export const defaultMemberTransactionListState = {
    isLoading: false
};
